import { superScriptify } from './formatText';

const getHeroInsetBoxModel = ({ heroContent = {}, heroType } = {}) => {
  const model = heroContent?.[heroType];
  const insetBoxModel = model?.membershipBox || {};

  // add text formatting that is not supported in ContentStack
  if (heroType === 'LOGGED_OUT' || heroType === 'NON_MEMBER') {
    const description = insetBoxModel?.description;
    const isAlreadyHTML = description?.includes('<strong>');
    if (description && !isAlreadyHTML) {
      const emdash = '—';
      const [text, emphasis] = description.split(emdash);
      if (emphasis) {
        insetBoxModel.description = `${text}${emdash}<strong>${emphasis}</strong>`;
      } else {
        insetBoxModel.description = text;
      }
    }
  }

  // add cta in object reference rather than array
  if (insetBoxModel?.links?.length) {
    const [cta] = insetBoxModel.links;
    insetBoxModel.footnoteCta = cta;
  }

  return insetBoxModel;
};

/*
 * `member-offer` groups are implemented incorrectly in ContentStack. Use with care.
 * This will be addressed in CONOPS-806. Until then, this gross adapter is required.
 */
const getMemberOfferModels = (memberOffers) => memberOffers.map((memberOffer, key) => {
  const { promotions } = memberOffer;
  const [promotionModel] = promotions;
  const { actions } = promotionModel;

  // *sigh* the CMS doesn't allow for a number of features that product wants,
  // so we hack them in by providing a number of adjustments to the model
  const modelOverrides = {};

  if (actions?.length > 0) {
    let nextActions = [];
    actions.forEach((action) => {
      // remove any link with the text "terms apply" from the actions array
      // and provide it to the component via a separate prop
      if (action?.text.toLowerCase().includes('terms apply')) {
        modelOverrides.inlineTermsLink = action;
        return;
      }
      // label any link with the href 'add-membership-to-cart' with a special prop that
      // allows the UI to render the actual 'add-membership-to-cart' button
      if (action?.href === 'add-membership-to-cart') {
        nextActions = [...nextActions, { ...action, addMembershipToCart: true }];
        return;
      }
      nextActions = [...nextActions, action];
    });

    modelOverrides.actions = nextActions;
  }

  // Add superscript for known characters, work-around for CMS that does not support HTML
  modelOverrides.heading = superScriptify(promotionModel.heading);
  modelOverrides.body = superScriptify(promotionModel.body);
  return {
    ...promotionModel,
    ...modelOverrides,
    key,
  };
});

// /*
//  * `member-offer` groups are implemented incorrectly in ContentStack. Use with care.
//  * This will be addressed in CONOPS-806. Until then, this gross adapter is required.
//  */
const getMemberPromoGroupModel = (memberOffers = []) => {
  const model = {
    promotions: getMemberOfferModels(memberOffers.slice(0, 3)),
  };
  const firstOffer = memberOffers[0] || {};
  model.heading = firstOffer.heading;
  model.subheading = firstOffer.subheading;

  return model;
};

export {
  getHeroInsetBoxModel,
  getMemberOfferModels,
  getMemberPromoGroupModel,
};
